import { NDA_STATES } from "../data/property/constants";

export const isNDAState = (stateCode) => NDA_STATES.includes(stateCode);
